import { useContext, createContext } from 'react';

var SelectContext = /*#__PURE__*/createContext(null);
var useSelectContext = function useSelectContext() {
  var value = useContext(SelectContext);

  if (!value) {
    throw new Error('No provider for SelectContext.');
  }

  return value;
};

export { SelectContext, useSelectContext };
